import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BUSINESS = {
  name: "Tombs Electronic Repair",
  llc: "Tombs Electronic Repair LLC",
  phone: "607-953-1221",
  phoneHref: "tel:+16079531221",
  email: "noahtroup0@gmail.com",
  emailHref: "mailto:noahtroup0@gmail.com",
  address: "67 Grand St, Susquehanna, PA 18847",
  hours: [
    { day: "Mon – Fri", time: "Email & Phone Calls Only" },
    { day: "Saturday", time: "Evening / Night Hours" },
    { day: "Sunday", time: "Open All Day" },
  ],
};
